import { Box, Group } from "@mantine/core";
import { Outlet, Route, Routes } from "react-router";
import { PageTitle } from "./PageTitle/PageTitle";
import { ProjectListBreadcrumb } from "./ProjectListBreadcrumb/ProjectListBreadcrumb";
import { SiteBreadcrumbs } from "./SiteBreadcrumbs/SiteBreadcrumbs";

function Breadcrumbs() {
  return (
    <Box
      aria-label="Breadcrumbs"
      component="nav"
      flex={1}
      miw={0}
      style={{ overflow: "hidden" }}
    >
      <Group
        component={"ul"}
        gap={0}
        m={0}
        miw={0}
        pl={30}
        style={{ listStyle: "none" }}
        wrap="nowrap"
      >
        <Routes>
          <Route path="/">
            <Route element={<PageTitle title="Modulauswahl" />} index />
            <Route path="manager">
              <Route path="projekte">
                <Route element={<PageTitle title="Dashboard" />} index />
                <Route
                  element={
                    <ProjectListBreadcrumb
                      listPath="/manager/projekte"
                      projectPath="/manager/projekte/:projectId"
                    />
                  }
                  path=":projectId"
                >
                  <Route path=":projectPage">
                    <Route
                      element={<PageTitle title="Projektübersicht" />}
                      index
                    />
                    <Route
                      element={<PageTitle title="Projektübersicht" />}
                      path="*"
                    />
                  </Route>
                  <Route element={<Outlet />} path="liegenschaften">
                    <Route
                      element={<PageTitle title="Projektübersicht" />}
                      index
                    />
                    <Route path=":siteId">
                      <Route element={<SiteBreadcrumbs />} index />
                      <Route element={<SiteBreadcrumbs />} path="*" />
                    </Route>
                  </Route>
                  <Route path="aufgaben">
                    <Route element={<PageTitle title="Aufgaben" />} index />
                    <Route element={<PageTitle title="Aufgaben" />} path="*" />
                  </Route>
                  <Route path="onboarding">
                    <Route element={<PageTitle title="Onboarding" />} index />
                    <Route
                      element={<PageTitle title="Onboarding" />}
                      path="*"
                    />
                  </Route>
                  <Route path="lieferungen-uebersicht">
                    <Route
                      element={<PageTitle title="Rechnungen und Verträge" />}
                      index
                    />
                    <Route
                      element={<PageTitle title="Rechnungen und Verträge" />}
                      path="*"
                    />
                  </Route>
                  <Route path="energiedaten">
                    <Route element={<PageTitle title="Energiedaten" />} index />
                    <Route
                      element={<PageTitle title="Energiedaten" />}
                      path="*"
                    />
                  </Route>
                  <Route path="history">
                    <Route element={<PageTitle title="Historie" />} index />
                    <Route element={<PageTitle title="Historie" />} path="*" />
                  </Route>
                  <Route path="paragraph6">
                    <Route element={<PageTitle title="§ 6 EEG" />} index />
                    <Route element={<PageTitle title="§ 6 EEG" />} path="*" />
                  </Route>
                  <Route path="erloesmonitoring">
                    <Route
                      element={<PageTitle title="Erlösmonitoring" />}
                      index
                    />
                    <Route
                      element={<PageTitle title="Erlösmonitoring" />}
                      path="*"
                    />
                  </Route>
                  <Route path="herkunftsnachweis">
                    <Route
                      element={<PageTitle title="Herkunftsnachweis" />}
                      index
                    />
                    <Route
                      element={<PageTitle title="Herkunftsnachweis" />}
                      path="*"
                    />
                  </Route>
                  <Route path="vermarktung">
                    <Route element={<PageTitle title="Vermarktung" />} index />
                    <Route
                      element={<PageTitle title="Vermarktung" />}
                      path="*"
                    />
                  </Route>
                </Route>
              </Route>
              <Route path="liegenschaften">
                <Route element={<PageTitle title="Liegenschaften" />} index />
                <Route
                  element={<PageTitle title="Liegenschaften" />}
                  path="*"
                />
              </Route>
              <Route path="history">
                <Route element={<PageTitle title="Historie" />} index />
                <Route element={<PageTitle title="Historie" />} path="*" />
              </Route>
              <Route path="erloesmonitoring">
                <Route element={<PageTitle title="Erlösmonitoring" />} index />
                <Route
                  element={<PageTitle title="Erlösmonitoring" />}
                  path="*"
                />
              </Route>
              <Route path="vermarktung">
                <Route element={<PageTitle title="Vermarktung" />} index />
                <Route element={<PageTitle title="Vermarktung" />} path="*" />
              </Route>
              <Route path="ppa-abrechnung">
                <Route element={<PageTitle title="PPA - Abrechnung" />} index />
                <Route
                  element={<PageTitle title="PPA - Abrechnung" />}
                  path="*"
                />
              </Route>
            </Route>
            <Route
              element={<PageTitle title="API-Einstellungen" />}
              path="api-einstellungen"
            />
            <Route
              element={<PageTitle title="Einstellungen" />}
              path="einstellungen"
            />
          </Route>
        </Routes>
      </Group>
    </Box>
  );
}

export { Breadcrumbs };
